import React, { Fragment, cloneElement } from 'react';
import cx from 'classnames';
import Clickable from '@move-ui/clickable';
import styles from './Chip.module.css';
export const Chip = ({ id, name, children, onClick, onLabelClick, className, isSetClassName, iconClassName, isSet, onIconClick, icon, ariaLabelIcon, disabled, inputRef, optionType = 'checkbox', tabIndex = 0, value, hideOutline, inputClassName }) => (React.createElement(Fragment, null,
    React.createElement("input", { id: id, name: name, type: optionType, onChange: onClick, checked: isSet, className: cx(inputClassName, styles.input, {
            [styles['hide-outline']]: hideOutline
        }), disabled: disabled, ref: inputRef, tabIndex: tabIndex, value: value }),
    React.createElement("label", { htmlFor: id, className: cx(styles.component, className, {
            [isSetClassName || '']: isSetClassName && isSet,
            [styles['has-clear-button']]: icon
        }), onClick: onLabelClick },
        children,
        icon && (React.createElement(Clickable, { onClick: onIconClick, className: styles.iconButton, "aria-label": ariaLabelIcon }, cloneElement(icon, {
            className: cx(icon.props.className, styles.icon, iconClassName)
        }))))));
//# sourceMappingURL=Chip.js.map